import { render, staticRenderFns } from "./demandDetail.vue?vue&type=template&id=72f27d3e&scoped=true&"
import script from "./demandDetail.vue?vue&type=script&lang=js&"
export * from "./demandDetail.vue?vue&type=script&lang=js&"
import style1 from "./demandDetail.vue?vue&type=style&index=1&id=72f27d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f27d3e",
  null
  
)

export default component.exports